import * as React from "react"
import {Box} from "@mui/material";

import ReverseMatcherTargetProduct from "./Product";
import ReverseMatcherTargetActions from "./Actions";


export default function ReverseMatcherTarget({ targetIndex, data, handleChangeIndex, isLoadingMapping}) {
    return <Box sx={{
        width: 1,
        height: 1,
        backgroundColor: 'background.neutral',
        borderRadius: 1,
        py: 5,
        px: 6.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        justifyContent: 'flex-start'
    }}>
        <ReverseMatcherTargetActions
            targetIndex={targetIndex}
            handleChangeIndex={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
        />

        <ReverseMatcherTargetProduct data={data} />
    </Box>
}